module.exports = __webpack_public_path__ + "static/media/coffeeshop_img.ce5ab566.png";